import {
  Button,
  Descriptions,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Spin
} from 'antd';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import EmpresaContext from '../context/empresa-context';
import { errorHandler } from '../utils';
import { instanceRef } from '../utils/axios';
import CustomCopyable from './CustomCopyable';

const { Option } = Select;

const GenerarEnlaceModal = ({
  form,
  idEmpresa,
  isModalOpen,
  setIsModalOpen,
  canalEnlace,
  usuarioEnlace, // modelo usuario
  idEnlace = null, // ID de enlace padre
  enlacePadre = null, // Enlace padre object,
  idEnlaceUsuarioToUpdate
}) => {
  const [loading, setLoading] = useState(false);
  const [productos, setProductos] = useState([]);
  const [enlaceGenerado, setEnlaceGenerado] = useState(false);
  const { empresa } = useContext(EmpresaContext);

  const { origin } = window.location;
  const esLocal = origin.includes('localhost');

  const handleClose = () => {
    setIsModalOpen(false);
    setEnlaceGenerado(null); // Reset the generated enlace when closing
    form.resetFields(); // Clear form fields
  };

  const handleFormSubmit = (values) => {
    generarEnlaceCorto(values).then((generatedEnlace) => {
      setEnlaceGenerado(generatedEnlace);
      form.resetFields();
    });
  };

  const generarEnlaceCorto = async (values) => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.post(`/enlace/generar`, {
        ...values,
        idEmpresa,
        idCanal: canalEnlace?.id,
        idUsuario: usuarioEnlace?.id,
        idProducto: Number(values.producto) || enlacePadre?.id_producto,
        idEnlace: idEnlace || null,
        idEnlaceUsuarioToUpdate
      });
      return response.data?.data; // Return enlacecorto generado
    } catch (error) {
      errorHandler(error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const fetchProductos = useCallback(async () => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.get(`/productos/all`);
      setProductos(response.data?.data);
    } catch (error) {
      // message.error('Error al obtener canal', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProductos();
  }, [fetchProductos]);

  return (
    <Modal
      title={enlaceGenerado ? 'Enlace Generado' : 'Agregar Enlace'}
      open={isModalOpen}
      onCancel={handleClose}
      footer={
        enlaceGenerado ? (
          <Button type="primary" onClick={handleClose}>
            Cerrar
          </Button>
        ) : (
          <Button
            type="primary"
            onClick={() => {
              form.validateFields().then((values) => {
                handleFormSubmit(values);
              });
            }}
          >
            Guardar
          </Button>
        )
      }
    >
      <Spin spinning={loading} size="large" tip="Cargando...">
        {!enlaceGenerado ? (
          <>
            {canalEnlace && (
              <Descriptions bordered size="small" column={1}>
                <Descriptions.Item label="Canal">
                  <Space>{canalEnlace?.descripcion}</Space>
                </Descriptions.Item>
              </Descriptions>
            )}
            {usuarioEnlace && (
              <Descriptions bordered size="small" column={1}>
                <Descriptions.Item label="Usuario">
                  <Space>{usuarioEnlace?.nombres}</Space>
                </Descriptions.Item>
                {enlacePadre && (
                  <Descriptions.Item label="Producto">
                    <Space>
                      {
                        productos.find(
                          (item) => item.id === enlacePadre.id_producto
                        )?.descripcion
                      }
                    </Space>
                  </Descriptions.Item>
                )}
              </Descriptions>
            )}
            <br />
            <Form form={form} layout="vertical">
              <Form.Item
                name="enlace_original"
                label="Enlace Original"
                initialValue={
                  esLocal
                    ? 'http://localhost:3000/'
                    : `https://${empresa.app_host}/`
                }
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                name="origen"
                label="Origen"
                rules={[{ required: true, message: 'Este campo es requerido' }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="campanha"
                label="Campaña"
                rules={[{ required: true, message: 'Este campo es requerido' }]}
              >
                <Input />
              </Form.Item>
              {!usuarioEnlace && (
                <Form.Item
                  name="producto"
                  label="Producto"
                  rules={[
                    { required: true, message: 'Este campo es requerido' }
                  ]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    style={{ width: 'auto' }}
                    dropdownStyle={{ minWidth: '190px' }}
                    optionFilterProp="children"
                    placeholder="Seleccionar Producto"
                  >
                    {productos?.map((item) => (
                      <Option key={item.codigo} value={`${item.id}`}>
                        {`${item.descripcion}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Form>
          </>
        ) : (
          <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label="Enlace Corto Generado">
              <Space>
                {enlaceGenerado.enlace_corto}
                <CustomCopyable
                  copyable={{
                    text: `${enlaceGenerado.enlace_corto}`,
                    tooltips: ['Copiar enlace', 'Copiado']
                  }}
                />
              </Space>
            </Descriptions.Item>
          </Descriptions>
        )}
      </Spin>
    </Modal>
  );
};

export default GenerarEnlaceModal;
